import { useI18n } from '@oneaudi/i18n-context';
export const useChangeRateTranslations = () => ({
    rateAlternativeText: useI18n({ id: 'nemo.ui.sc.details.finance.rate.alternativeText' }),
    disclaimerText: useI18n({
        id: 'nemo.ui.sc.details.finance.disclaimer.text',
        defaultMessage: '',
    }),
    rateText1: `${useI18n({
        id: 'nemo.ui.sc.details.finance.rate.text1',
        defaultMessage: '',
    })} `,
    rateText2: `${useI18n({
        id: 'nemo.ui.sc.details.finance.rate.text2',
        defaultMessage: '',
    })} `,
    rateChange: useI18n({
        id: 'nemo.ui.sc.details.finance.rate.button.change',
        defaultMessage: 'Change rate',
    }),
    errorHeadline: useI18n({
        id: 'nemo.ui.sc.details.finance.error.headline',
        defaultMessage: '',
    }),
    errorMessage: useI18n({
        id: 'nemo.ui.sc.details.finance.error.text',
        defaultMessage: '',
    }),
    errorCloseButton: useI18n({
        id: 'nemo.ui.sc.details.finance.error.button.close',
        defaultMessage: '',
    }),
    dialogSuccessAriaLabel: useI18n({
        id: 'nemo.ui.sc.details.finance.layer.success.aria.label',
        defaultMessage: '',
    }),
    dialogInnerSuccessAriaLabel: useI18n({
        id: 'nemo.ui.sc.details.finance.inner.layer.success.aria.label',
        defaultMessage: '',
    }),
    dialogCloseButtonAriaLabel: useI18n({
        id: 'nemo.ui.sc.details.finance.layer.close.button.aria.label',
        defaultMessage: ' Close the FS dialog',
    }),
    dialogErrorAriaLabel: useI18n({
        id: 'nemo.ui.sc.details.finance.layer.error.aria.label',
        defaultMessage: '',
    }),
    dialogInnerErrorAriaLabel: useI18n({
        id: 'nemo.ui.sc.details.finance.inner.layer.error.aria.label',
        defaultMessage: '',
    }),
    dialogErrorCloseButtonAriaLabel: useI18n({
        id: 'nemo.ui.sc.details.finance.layer.error.close.button.aria.label',
        defaultMessage: 'Close the FS error dialog',
    }),
});
